import { defineMessages } from "react-intl";

export const loyaltyTagMultiUpdateResultsMessages = defineMessages({
  fileProcessed: {
    id: "loyaltyTagMultiUpdateResults.fileProcessed",
    defaultMessage: "File processed",
  },
  header: {
    id: "loyaltyTagMultiUpdateResults.header",
    defaultMessage: "Results",
  },
  created: {
    id: "loyaltyTagMultiUpdateResults.created",
    defaultMessage: "Created preferences",
  },
  deleted: {
    id: "loyaltyTagMultiUpdateResults.deleted",
    defaultMessage: "Deleted preferences",
  },
  errors: {
    id: "loyaltyTagMultiUpdateResults.errors",
    defaultMessage: "Errors",
  },
  alertSomeErrors: {
    id: "loyaltyTagMultiUpdateResults.alertSomeErrors",
    defaultMessage: "Following rows haven't been processed",
  },
  headerErrors: {
    id: "loyaltyTagMultiUpdateResults.headerErrors",
    defaultMessage: "Errors list",
  },
  ticker: {
    id: "loyaltyTagMultiUpdateResults.ticker",
    defaultMessage: "Ticker",
  },
  code: {
    id: "loyaltyTagMultiUpdateResults.code",
    defaultMessage: "Code",
  },
  message: {
    id: "loyaltyTagMultiUpdateResults.message",
    defaultMessage: "Message",
  },
});
